import regexFormula from '@/constants/regex'

export default {
  methods: {
    isNumericOnlyMixin (e) {
      const char = String.fromCharCode(e.keyCode)
      if (regexFormula.NUMERIC.test(char)) return true
      else e.preventDefault()
    },
    isAlphaNumericOnlyMixin (e) {
      const char = String.fromCharCode(e.keyCode)
      if (regexFormula.ALPHA_NUMERIC.test(char)) return true
      else e.preventDefault()
    },
    isNumericDotOnlyMixin (e) {
      const char = String.fromCharCode(e.keyCode)
      if (regexFormula.NUMERIC_AND_DOT.test(char)) return true
      else e.preventDefault()
    }
  }
}
